import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import Home from './pages/Home';
import Workspaces from './pages/Workspaces';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './pages/LegalPages/PrivacyPolicy';
import TermsAndConditions from './pages/LegalPages/TermsAndConditions';
import RefundPolicy from './pages/LegalPages/RefundPolicy';
import SubscriptionPolicy from './pages/LegalPages/SubscriptionPolicy';
import CookiePolicy from './pages/LegalPages/CookiePolicy';
import AIUseAndContentPolicy from './pages/LegalPages/AIUseAndContentPolicy';
import AcceptableUsePolicy from './pages/LegalPages/AcceptableUsePolicy';
import Pricing from './pages/Pricing';
import Authentication from './pages/Authentication';
import ChoosePlan from './pages/ChoosePlan';
import Checkout from './pages/Checkout';
import UpgradeCheckout from './pages/UpgradeCheckout';
import PaymentCallBack from './pages/PaymentCallBack';
import PaymentOutcome from './pages/PaymentOutcome';
import BuyCredits from "./pages/BuyCredits";
import CreditsPurchaseOutcome from './pages/CreditsPurchaseOutcome';
import UpgradePaymentOutcome from './pages/UpgradePaymentOutcome';
import KairosEditor from './pages/KairosEditor';


const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/subscription-policy" element={<SubscriptionPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/ai-use-policy" element={<AIUseAndContentPolicy />} />
            <Route path="/acceptable-use-policy" element={<AcceptableUsePolicy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/authentication" element={<Authentication />} />
            <Route path="/choose-plan" element={<ChoosePlan />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/upgrade-checkout" element={<UpgradeCheckout />} />
            <Route path="/payment-callback" element={<PaymentCallBack />} />
            <Route path="/payment-outcome" element={<PaymentOutcome />} />
            <Route path="/buy-credits" element={<BuyCredits />} />
            <Route path="/credits-purchase-outcome" element={<CreditsPurchaseOutcome />} />
            <Route path="/upgrade-payment-outcome" element={<UpgradePaymentOutcome />} />
            <Route path="/kairos/:websiteId" element={<KairosEditor />} />
            {/* Protected Route: The workspaces page */}
            <Route
              path="/workspace"
              element={
                <ProtectedRoute>
                  <Workspaces />
                </ProtectedRoute>
              }
            />
          </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
